<template>
  <router-view />
</template>

<script>
import './assets/css/fonts.css';
import './assets/config/cssimporter';

export default {
  name: 'App',

  data() {
    return {
      currentVersion: null,
      checkInterval: null,
    };
  },

  mounted() {
    // Jalankan pengecekan versi saat halaman pertama kali dimuat
    this.startVersionCheck();
  },

  beforeUnmount() {
    // Hentikan interval saat komponen dilepas
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  },

  methods: {
    async checkVersion() {
      try {
        const res = await fetch('/version.json?cache=' + Date.now());
        const { version } = await res.json();

        // Jika versi berubah, reload aplikasi
        if (this.currentVersion && this.currentVersion !== version) {
          console.log('⚡ Versi baru terdeteksi:', version);

          // Bisa pilih salah satu:
          // 1️⃣ Reload langsung tanpa konfirmasi
          // window.location.reload(true);

          // 2️⃣ Tampilkan alert sebelum reload (lebih ramah user)
          //alert('Perbaikan baru untuk aplikasi tersedia. Halaman akan dimuat ulang.');
          window.location.reload(true);
        }

        this.currentVersion = version;
      } catch (e) {
        console.warn('Gagal memeriksa versi:', e);
      }
    },

    startVersionCheck() {
      // Jalankan pertama kali saat mount
      this.checkVersion();

      // Cek setiap 15 detik
      this.checkInterval = setInterval(this.checkVersion, 10000);
    },
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
#app {
  font-family: poppins-reg;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
}
h1, h2, h3, h4, h5 {
  font-family: poppins-semi;
}
</style>
